var Reflux = require('reflux');
var DappsActions = require('../actions/DappsActions');
var Identicon = require("identicon.js");

const options = {
    //  foreground: [255, 255, 255, 255],               // rgba black
    background: [255, 152, 0, 0], // rgba white
    margin: 0.2, // 20% margin
    size: 420, // 420px square
    format: 'svg' // use SVG instead of PNG
};

const server = 'https://dappstore.link/';

var DappsStore = Reflux.createStore({
    data: {
    },
    defaultDapp: {
        title: 'loading...',
        balance: 0,
        dau: 0,
        category: 'other',
        hash: 'cfcd208495d565ef66e7dff9f98764da',
        image: '',
        slug: '',
    },
    isLoadAllDapp: false,
    listenables: [DappsActions],
    init: function() {
        this.data = {
            searchQuery: '',
            dappsIcons: [],
            dapps: [],
            top: [],
            total: [],
            categories: [],
        };
        this.getHeadDataPromise.then(function(e) {
            DappsStore.data.total = e.total;
            DappsStore.data.categories = e.categories;
            DappsStore.data.dapps = e.dapps;
            DappsStore.data.dapps.forEach((element) => {
                if (!element.image) {
                    DappsStore.data.dappsIcons[element.id] = new Identicon(element.hash, options).toString();
                }
                if (element.top) {
                    DappsStore.addToTop(element);
                }
            });
            DappsStore.doTrigger();
        }).then(this.getAllDapps);
    },
    getAllDapps: function() {
        return new Promise(function(resolve) {
            if (DappsStore.isLoadAllDapp) {
                resolve(DappsStore.data.dapps);
            } else {
                DappsStore.getDappsPromise.then(function(e) {
                    DappsStore.data.dapps = e;
                    DappsStore.data.isLoadAllDapp = true;
                    DappsStore.data.dapps.forEach((element) => {
                        if (!element.image) {
                            DappsStore.data.dappsIcons[element.id] = new Identicon(element.hash, options).toString();
                        }
                        if (element.top) {
                            DappsStore.addToTop(element);
                        }
                    });
                    DappsStore.doTrigger();
                    resolve(e);
                });
            }
        });
    },
    getHeadDataPromise: fetch(server + 'api/get-head-data').then(r => r.json()),
    getDappsPromise: fetch(server + 'api/get-dapps').then(r => r.json()),
    doTrigger: function() {
        DappsStore.trigger(this.data);
    },
    addToTop: function(dapp) {
        let isSet = this.data.top.find(function(element) {
            return element.id === dapp.id;
        });
        if (!isSet) {
            this.data.top.push(dapp);
        }
    },
    getDappById: function(id) {
        if (typeof this.data.dapps === 'object') {
            return this.data.dapps.find(function(element) {
                return element.id === id;
            });
        } else {
            return this.defaultDapp;
        }
    /*
    if (typeof this.data.dapps[id] !== 'undefined') {
        return this.data.dapps[id];
    } else {
        return this.defaultDapp;
    }
    */
    },
    getIconById: function(id) {
        if (typeof this.data.dappsIcons[id] !== 'undefined') {
            return this.data.dappsIcons[id];
        } else {
            return new Identicon(this.defaultDapp.hash, options).toString();
        }
    },
    getDappBySlug: function(slug) {
        if (typeof this.data.dapps === 'object') {
            return this.data.dapps.find(function(element) {
                return element.slug === slug;
            });
        } else {
            return false;
        }
    },
    getCountersCategory: function(category) {
        if (typeof this.data.categories !== 'undefined') {
            if (typeof this.data.categories[category] !== 'undefined') {
                return this.data.categories[category];
            } else {
                return {
                    "dapps": this.data.total.dapps,
                    "dau": this.data.total.dau,
                    "balance": this.data.total.balance,
                    "tx": this.data.total.tx
                };
            }
        }
        return {
            "dapps": 0,
            "dau": 0,
            "balance": 0,
            "tx": 0
        };
    },
    /*
        "primary",
    "warning",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
    */

    getColorByCategory: function(category) {
        switch (category) {
        case 'game':
        case 'games':
            return {
                name: 'orange',
                type: 'warning'
            };
        case 'marketplace':
        case 'marketplaces':
            return {
                name: 'green',
                type: 'success'
            };
        case 'pyramid':
        case 'pyramids':
        case 'casino':
        case 'casinos':
            return {
                name: 'red',
                type: 'danger'
            };
        default:
            return {
                name: 'blue',
                type: 'info'
            };
        }
    },
    onChangeSearchQuery: function(text) {
        this.data.searchQuery = text;
        if (text) {
            this.getAllDapps();
        }
        DappsStore.doTrigger();
    },
    getRelatedDapps: function(dapp) {
        let dapps = this.data.dapps.filter((e) => e.category === dapp.category);
        dapps.sort((a, b) => (b.dau - a.dau));
        let index = dapps.indexOf(dapp);
        if (index < 3) {
            index = 0;
        } else if (index > dapps.length - 7) {
            index = dapps.length - 7;
        } else {
            index -= 3;
        }
        dapps = dapps.filter((e) => e.id !== dapp.id);
        dapps = dapps.filter((e) => !e.top);
        dapps = dapps.slice(index, index + 6);
        let topDapps = this.data.top.filter((e) => e.category === dapp.category && e.id !== dapp.id);
        topDapps.forEach(function(topItem) {
            dapps.unshift(topItem);
        });
        dapps = dapps.slice(0, 6);
        return dapps;
    },
    sortPreviousDau: function(a, b) {
        if (a.top || b.top) {
            return b.top - a.top;
        }
        return (b.dau - b.previous_dau) - (a.dau - a.previous_dau);
    },
    sortDau: function(a, b) {
        if (a.top || b.top) {
            return b.top - a.top;
        }
        return b.dau - a.dau;
    },
    sortBalance: function(a, b) {
        if (a.top || b.top) {
            return b.top - a.top;
        }
        return b.balance - a.balance;
    }
});

module.exports = DappsStore;



// WEBPACK FOOTER //
// ./src/stores/DappsStore.js